module.exports = __webpack_public_path__ + "img/freddies_flowers_stacked.adce1499.svg";